var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-paypal-form',{attrs:{"total":_vm.total},on:{"success":_vm.onSuccess,"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }